import actionNames from './actionNames'

const mutations = {
  columns(state, columns) {
    state.columns = { ...state.columns, ...columns }
  },
  publisher(state, publisher) {
    state.publisher = publisher
  },
  subId(state, subId) {
    state.subId = subId
  },
  summaries(state, columns) {
    state.summaries = { ...state.summaries, ...columns }
  },

  [actionNames.GET_PUBLISHER_REQUESTED](state) {
    state.isLoadingPublisher = true
    state.didLoadPublisherFail = false
  },
  [actionNames.GET_PUBLISHER_SUCCEEDED](state, publisher) {
    state.isLoadingPublisher = false
    state.didLoadPublisherFail = false
    state.publisher = publisher
  },
  [actionNames.GET_PUBLISHER_FAILED](state, error) {
    state.isLoadingPublisher = false
    state.didLoadPublisherFail = error || error === false ? error : true
  },

  [actionNames.GET_HEALTH_ADX_REQUESTED](state) {
    state.isLoadingProgrammatic = true
    state.didLoadProgrammaticFail = false
  },
  [actionNames.GET_HEALTH_ADX_SUCCEEDED](state, health) {
    state.isLoadingProgrammatic = false
    state.didLoadProgrammaticFail = false

    state.health = health
  },
  [actionNames.GET_HEALTH_ADX_FAILED](state) {
    state.isLoadingProgrammatic = false
    state.didLoadProgrammaticFail = true
  },

  [actionNames.GET_HEALTH_NETWORK_REQUESTED](state) {
    state.isLoadingProgrammatic = true
    state.didLoadProgrammaticFail = false
  },
  [actionNames.GET_HEALTH_NETWORK_SUCCEEDED](state, health) {
    state.isLoadingProgrammatic = false
    state.didLoadProgrammaticFail = false

    state.health = health
  },
  [actionNames.GET_HEALTH_NETWORK_FAILED](state) {
    state.isLoadingProgrammatic = false
    state.didLoadProgrammaticFail = true
  },

  [actionNames.GET_YIELD_PARTNER_REQUESTED](state) {
    state.isLoadingProgrammatic = true
    state.didLoadProgrammaticFail = false
  },
  [actionNames.GET_YIELD_PARTNER_SUCCEEDED](state, response) {
    state.isLoadingProgrammatic = false
    state.didLoadProgrammaticFail = false

    state.yield = response
  },
  [actionNames.GET_YIELD_PARTNER_FAILED](state) {
    state.isLoadingProgrammatic = false
    state.didLoadProgrammaticFail = true
  },

  [actionNames.GET_PROGRAMMATIC_REQUESTED](state) {
    state.isLoadingProgrammatic = true
    state.didLoadProgrammaticFail = false
  },
  [actionNames.GET_PROGRAMMATIC_SUCCEEDED](state, programmatic) {
    state.isLoadingProgrammatic = false
    state.didLoadProgrammaticFail = false

    state.programmatic = programmatic
  },
  [actionNames.GET_PROGRAMMATIC_FAILED](state) {
    state.isLoadingProgrammatic = false
    state.didLoadProgrammaticFail = true
  },

  [actionNames.SHOW_PROGRAMMATIC_VIEW](state, status) {
    state.isLoadingPublisher = false
    state.isLoadingProgrammatic = false
    state.programmaticViewStatus = status
  },
}

export default mutations
